import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setConfirmDecline,
  setConfirmed,
} from '@sonifi/wb-notifier/store/notifierSlice';

const Confirm = ({ scope }) => {
  const { buttons, content, id, isOpened, title } = useSelector(
    (state) => state.notifier.confirm[scope],
  );
  const dispatch = useDispatch();

  if (!isOpened || id !== scope) {
    return null;
  }

  return (
    <>
      <div
        className="notifier-backdrop am-fade"
        style={{ position: 'fixed', inset: '0px', zIndex: 100 }}
      ></div>
      <div
        className={`alert alert-confirm ${content ? 'confirm-with-content' : ''}`}
      >
        <strong>{title}</strong>
        <span dangerouslySetInnerHTML={{ __html: content }}></span>
        <div className="confirm-buttons-container">
          {buttons.confirm && (
            <button
              className="primary"
              onClick={() => dispatch(setConfirmed({ id }))}
            >
              {buttons.confirm}
            </button>
          )}
          {buttons.cancel && (
            <button onClick={() => dispatch(setConfirmDecline({ id }))}>
              {buttons.cancel}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Confirm;
